import { Frame, Reveal, Label, Headline, Cell, Arrow } from "./SlideKit";

export const SlideTitle = () => (
  <div className="w-full h-full flex flex-col justify-center px-8 sm:px-16 lg:px-24 relative">
    <Reveal>
      <Label className="text-[#dd6611]">X Scale — Strategic Dossier</Label>
    </Reveal>
    <Reveal delay={0.2}>
      <h1 className="text-5xl sm:text-6xl lg:text-8xl font-extralight tracking-tighter text-white mt-8 leading-[0.95]">
        Averra <span className="text-neutral-500">Life</span>
      </h1>
    </Reveal>
    <Reveal delay={0.4}>
      <div className="text-xl sm:text-2xl font-light text-neutral-400 mt-6">
        Go-to-Market Strategy — a decision-ready narrative
      </div>
    </Reveal>
    <Reveal delay={0.6} className="mt-16 flex flex-col sm:flex-row gap-8 border-t border-neutral-800 pt-6 max-w-2xl">
      <Label>Audience — Michael &amp; Averra Life Leadership</Label>
      <Label>Narrated by Xena — X Scale Concierge</Label>
    </Reveal>
  </div>
);

export const Slide1 = () => (
  <Frame num="01" section="The Executive Thesis">
    <Headline>
      Build the authority. Own the demand. <span className="text-[#dd6611]">Scale the care.</span>
    </Headline>
    <Reveal delay={0.4} className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-px bg-neutral-800 border border-neutral-800 max-w-5xl">
      {[
        ["Thomas Medical", "Clinical foundation"],
        ["Robert Thomas", "Authority & trust"],
        ["X Scale", "Demand & growth engine"],
        ["RAVE", "Execution & retention"],
      ].map(([t, s]) => (
        <div key={t} className="bg-[#050505] p-6">
          <div className="text-lg text-white font-normal">{t}</div>
          <div className="font-mono text-[10px] tracking-[0.15em] uppercase text-neutral-500 mt-2">{s}</div>
        </div>
      ))}
    </Reveal>
    <Reveal delay={0.7} className="max-w-5xl">
      <div className="flex flex-col items-center mt-0">
        <div className="w-px h-10 bg-neutral-700" />
        <div className="border border-[#dd6611] px-10 py-4 text-white text-lg tracking-wide">
          AVERRA <span className="text-[#dd6611]">LIFE</span>
        </div>
        <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-neutral-500 mt-4 text-center max-w-xl">
          Expert-led health media on the front end — recurring health optimization platform on the back end
        </div>
      </div>
    </Reveal>
  </Frame>
);

export const Slide2 = () => (
  <Frame num="02" section="Product & Market Position">
    <Headline>
      Not a peptide, prescription, or appointment. <span className="text-neutral-500">A continuously evolving plan for better health.</span>
    </Headline>
    <div className="mt-12 grid lg:grid-cols-[1fr_auto_1fr] gap-8 items-center max-w-5xl">
      <Reveal delay={0.4} className="grid grid-cols-2 gap-px bg-neutral-800 border border-neutral-800">
        {["Sleep", "Exercise", "Nutrition", "Stress"].map((p, i) => (
          <div key={p} className="bg-[#050505] p-5">
            <span className="font-mono text-[10px] text-[#dd6611] mr-3">0{i + 1}</span>
            <span className="text-white">{p}</span>
          </div>
        ))}
      </Reveal>
      <Reveal delay={0.55}><Arrow className="hidden lg:block text-2xl" /></Reveal>
      <Reveal delay={0.6}>
        <div className="border border-[#dd6611] p-6">
          <Label className="text-[#dd6611]">The Organizing Product</Label>
          <div className="text-2xl text-white font-light mt-2">Personal Health Plan</div>
          <div className="font-mono text-[11px] tracking-[0.15em] text-neutral-400 mt-4">
            STABILIZE <span className="text-[#dd6611]">→</span> ENHANCE <span className="text-[#dd6611]">→</span> OPTIMIZE
          </div>
        </div>
      </Reveal>
    </div>
    <Reveal delay={0.8} className="mt-10 border-t border-neutral-800 pt-5 max-w-5xl flex flex-col sm:flex-row justify-between gap-4">
      <Label>Category — Guided Health Optimization</Label>
      <div className="text-neutral-400 text-sm font-light italic">
        “Know what your body needs. Have a plan. Keep getting better.”
      </div>
    </Reveal>
  </Frame>
);

export const Slide3 = () => (
  <Frame num="03" section="Membership & Delivery Model">
    <Headline>
      One clinical standard. <span className="text-[#dd6611]">Two ways to execute it.</span>
    </Headline>
    <div className="mt-10 grid md:grid-cols-2 gap-px bg-neutral-800 border border-neutral-800 max-w-5xl">
      {[
        {
          name: "Concierge",
          rows: ["Telehealth-first", "Labs through local partners", "Physical services via LCP network", "Meds & supplements shipped", "Nationally scalable where licensed"],
        },
        {
          name: "Concierge Plus",
          rows: ["Telehealth + Averra center", "Labs & assessments on site", "Services delivered at the center", "In-clinic administration", "Premium location-based experience"],
        },
      ].map((col, ci) => (
        <Reveal key={col.name} delay={0.4 + ci * 0.15} className="bg-[#050505] p-6">
          <div className="text-xl text-white">{col.name}</div>
          <div className="mt-4 space-y-2.5">
            {col.rows.map((r) => (
              <div key={r} className="text-sm text-neutral-400 font-light border-b border-neutral-900 pb-2">{r}</div>
            ))}
          </div>
        </Reveal>
      ))}
    </div>
    <Reveal delay={0.8} className="max-w-5xl border border-neutral-800 border-t-0 p-4 flex flex-wrap items-center gap-x-6 gap-y-2">
      <Label className="text-[#dd6611]">Shared Foundation</Label>
      <Label>One Personal Health Plan · PHP Advisor · Quarterly Reassessment · RAVE Tracking</Label>
    </Reveal>
  </Frame>
);

export const Slide4 = () => (
  <Frame num="04" section="North Carolina Launch & Expansion">
    <Headline>
      Prove it locally. Scale it market by market. <span className="text-neutral-500">Replicate it state by state.</span>
    </Headline>
    <div className="mt-12 max-w-5xl grid lg:grid-cols-[1.2fr_1fr] gap-12">
      <div>
        {[
          ["Pinehurst", "First operating cell — Thomas Medical"],
          ["Raleigh", "Large, high-value expansion market"],
          ["Charlotte", "Major metropolitan growth market"],
          ["Wilmington", "Coastal market & regional density"],
        ].map(([city, sub], i) => (
          <Reveal key={city} delay={0.4 + i * 0.12} className="flex items-baseline gap-6 border-b border-neutral-800 py-4">
            <span className="font-mono text-[11px] text-[#dd6611]">0{i + 1}</span>
            <span className="text-2xl font-light text-white w-40">{city}</span>
            <span className="font-mono text-[10px] tracking-[0.12em] uppercase text-neutral-500 hidden sm:block">{sub}</span>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.7}>
        <Label className="mb-4">Expansion Sequence</Label>
        <div className="space-y-3">
          {["Prove Pinehurst — offer, funnel, Welcome Call", "Launch Raleigh, Charlotte, Wilmington cells", "Expand statewide — telehealth + LCP network", "Enter new states — licensed playbook"].map((p, i) => (
            <div key={p} className="flex items-center gap-4">
              <span className="font-mono text-[10px] text-neutral-600">PH{i + 1}</span>
              <div className="h-px flex-none w-6 bg-[#dd6611]" />
              <span className="text-sm text-neutral-400 font-light">{p}</span>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </Frame>
);

export const Slide5 = () => (
  <Frame num="05" section="The Acquisition Engine">
    <Headline>
      Meta creates demand. Google captures intent. <span className="text-[#dd6611]">Three funnels, one conversation.</span>
    </Headline>
    <div className="mt-12 max-w-4xl flex flex-col items-center">
      {[
        ["Evergreen Webinar", "Deepest trust & education", "w-full"],
        ["Quiz / Assessment", "Participation & segmentation", "w-[78%]"],
        ["Direct Response", "Ad → landing page → application", "w-[56%]"],
      ].map(([t, s, w], i) => (
        <Reveal key={t} delay={0.4 + i * 0.15} className={`${w}`}>
          <div className="border border-neutral-800 bg-[#050505] px-6 py-4 flex items-center justify-between mb-2">
            <span className="text-white">{t}</span>
            <span className="font-mono text-[10px] tracking-[0.12em] uppercase text-neutral-500 hidden sm:block">{s}</span>
          </div>
        </Reveal>
      ))}
      <Reveal delay={0.85} className="w-[40%] flex justify-center">
        <div className="w-px h-8 bg-neutral-700" />
      </Reveal>
      <Reveal delay={0.95}>
        <div className="border border-[#dd6611] px-8 py-4 font-mono text-[11px] tracking-[0.18em] uppercase text-white">
          Application <span className="text-[#dd6611]">→</span> Welcome Call <span className="text-[#dd6611]">→</span> Concierge
        </div>
      </Reveal>
      <Reveal delay={1.1} className="mt-6">
        <Label>Retargeting loop — Webinar non-converter → Quiz → Direct application</Label>
      </Reveal>
    </div>
  </Frame>
);
